import React from 'react';
import { VideoElement as VideoType } from '../../types/element.types';

interface VideoElementProps {
  element: VideoType;
}

/**
 * Video Element Renderer
 * Supports YouTube, Vimeo, and custom video URLs
 */
const VideoElement: React.FC<VideoElementProps> = ({ element }) => {
  const { url, provider } = element.content || { url: '', provider: 'youtube' };
  const { autoplay, controls, loop, muted } = element.settings || {};

  const getEmbedUrl = () => {
    if (provider === 'youtube') {
      const videoId = url.includes('v=') ? url.split('v=')[1]?.split('&')[0] : url.split('/').pop();
      const params = new URLSearchParams({
        autoplay: autoplay ? '1' : '0',
        controls: controls ? '1' : '0',
        loop: loop ? '1' : '0',
        mute: muted ? '1' : '0',
      });
      return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
    }
    
    if (provider === 'vimeo') {
      const videoId = url.split('/').pop();
      return `https://player.vimeo.com/video/${videoId}`;
    }
    
    return url;
  };

  if (provider === 'custom') {
    return (
      <video
        src={url}
        controls={controls}
        autoPlay={autoplay}
        loop={loop}
        muted={muted}
        className="video-element"
        style={element.styles as React.CSSProperties}
      />
    );
  }

  return (
    <div
      className="video-element"
      style={{
        ...element.styles,
        position: 'relative',
        paddingBottom: '56.25%', // 16:9 aspect ratio
        height: 0,
        overflow: 'hidden',
      } as React.CSSProperties}
    >
      <iframe
        src={getEmbedUrl()}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
      />
    </div>
  );
};

export default VideoElement;

